import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import { useTranslation } from 'react-i18next'

export default function ContactCTA() {
  const { t } = useTranslation()
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 })

  return (
    <section className="py-24" id="contact" ref={ref}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={inView ? { opacity: 1, scale: 1 } : {}}
          transition={{ duration: 0.6 }}
          className="bg-primary rounded-[3rem] p-12 text-center text-white relative overflow-hidden"
        >
          <div className="relative z-10 max-w-2xl mx-auto space-y-8">
            <h2 className="text-4xl lg:text-5xl font-bold">{t('contact.title')}</h2>
            <p className="text-xl text-white/80">{t('contact.subtitle')}</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/contact"
                className="px-10 py-5 bg-white text-primary rounded-2xl font-bold text-xl hover:scale-105 transition-transform shadow-xl"
              >
                {t('contact.ctaExpert')}
              </Link>
              <button className="px-10 py-5 bg-white/20 text-white border border-white/30 rounded-2xl font-bold text-xl hover:bg-white/30 transition-all">
                {t('contact.ctaBrochure')}
              </button>
            </div>
          </div>
          <div className="absolute top-0 left-0 w-96 h-96 bg-white/10 rounded-full -ml-48 -mt-48 blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-accent/20 rounded-full -mr-48 -mb-48 blur-3xl"></div>
        </motion.div>
      </div>
    </section>
  )
}
